module.exports = __webpack_public_path__ + "static/sportovni-den-2022-04-ea9eb92775b553ebd94dd083cb3c22b5.jpg";